import { render, staticRenderFns } from "./user-management-mitra.vue?vue&type=template&id=0f1f6c52&scoped=true"
import script from "./user-management-mitra.vue?vue&type=script&lang=js"
export * from "./user-management-mitra.vue?vue&type=script&lang=js"
import style0 from "./user-management-mitra.css?vue&type=style&index=0&id=0f1f6c52&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f6c52",
  null
  
)

export default component.exports